import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { fetchMe, logout as apiLogout } from "@/lib/api";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = checking, false = signed out

    useEffect(() => {
        fetchMe()
            .then(setUser)
            .catch(() => setUser(false));
    }, []);

    const signOut = useCallback(async () => {
        try {
            await apiLogout();
        } finally {
            setUser(false);
        }
    }, []);

    return (
        <AuthContext.Provider value={{ user, setUser, signOut }}>
            {children}
        </AuthContext.Provider>
    );
}
